import WebIcon from "@material-ui/icons/Web"
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo"
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf"
import React from "react"

export const getDefaultThumbnail = mimeType => {
  if (!mimeType || mimeType === 'link') return <WebIcon className='playlist-item-thumbnail-icon' />
  return mimeType.includes('video') ? <OndemandVideoIcon className='playlist-item-thumbnail-icon' /> : <PictureAsPdfIcon className='playlist-item-thumbnail-icon' />
}
